// extracted by mini-css-extract-plugin
var _1 = "NumberCell-moduleavatar__Yv6nZ";
export { _1 as "avatar" }
